import { render, staticRenderFns } from "./BB-highlighting.vue?vue&type=template&id=79263e3f&scoped=true&"
import script from "./BB-highlighting.vue?vue&type=script&lang=js&"
export * from "./BB-highlighting.vue?vue&type=script&lang=js&"
import style0 from "./BB-highlighting.vue?vue&type=style&index=0&id=79263e3f&prod&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79263e3f",
  null
  
)

export default component.exports